<template>
  <div class="view">
    <div class="content">
      <div class="condition">
        <div class="search_wrap">
          <el-form :model="formdata" class="form-inline" :inline="true">
            <el-form-item>
              <el-input v-model="formdata.name" placeholder="请输入运费模板名称" size="small"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="search" size="small"></el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="other_wrap">
          <el-button type="primary" @click="addfreight" size="small">新建运费模板</el-button>
        </div>
      </div>
      <div class="table_wrap">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="name" label="模版名称"></el-table-column>
          <el-table-column prop="update_time" label="更新时间"></el-table-column>
          <!-- <el-table-column prop="goods_info" label="关联商品"></el-table-column> -->
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="edit(scope.row.id)">查看</el-button>
              <el-button type="text" size="small" @click="del(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pag_wrap">
          <el-pagination
            background
            @current-change="pageIndexChange"
            :page-size="page.pagesize"
            :current-page="page.pageindex"
            layout="total, prev, pager, next"
            :total="page.total"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/api.js";
import { pagination } from "@/util/util.js";
export default {
  name: "freightTemplateList",
  data() {
    return {
      formdata: {
        name: ""
      },
      tableData: [],
      page: {
        pageindex: pagination.pageIndex,
        pagesize: pagination.pageSize,
        total: pagination.total
      }
    };
  },
  created() {
    this.init();
  },
  methods: {
    // 搜索
    search() {
      this.init();
    },
    //初始化请求
    init() {
      this.page.pageindex = 1;
      this.querylist();
    },
    //查询列表
    querylist() {
      let params = {
        page: this.page.pageindex,
        name: this.formdata.name
      };
      this.axios
        .post(api.freight_index, params)
        .then(response => {
          if (response.data.code == 0) {
            this.tableData = response.data.list;
            this.page.total = response.data.all_page;
          } else {
            this.page.total = 0;
          }
        })
        .catch(() => {});
    },
    // 分页
    pageIndexChange(pageindex) {
      this.page.pageindex = pageindex;
      this.querylist();
    },
    addfreight() {
      this.$router.push({ name: "createFreight" });
    },
    // 编辑
    edit(id) {
      this.$router.push({ name: "createFreight", query: { id: id } });
    },
    // 删除
    del(id) {
      let params = {
        fre_id: id
      };
      this.axios
        .post(api.freight_delete, params)
        .then(response => {
          if (response.data.code == 0) {
            this.$message({
              message: "删除成功",
              type: "success"
            });
            this.init();
          } else {
            this.page.total = 0;
          }
        })
        .catch(() => {});
    }
  }
};
</script>
